import React from 'react';
export function EditorClearStyleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M10.031 11.446L1.586 3h2.828l18 18h-2.828l-8.01-8.01L8.462 21H6.316l3.715-9.554zM12.538 5H9L7 3h14v2h-6.316l-1.721 4.427-1.546-1.545L12.538 5z"
  }));
}